// ##### 25-03-26 Komarov
import React from 'react';
import { Helmet } from 'react-helmet-async';

// ##### Komarov 2025-07-14
const SeoMetaTitle = ({ metaTitleObjectText }) => {
  return (
    <Helmet>
      {/* ##### 24-09-13 Komarov */}
      <title>{metaTitleObjectText}</title>
    </Helmet>
  );
};

// ##### 25-05-21 Komarov
export default SeoMetaTitle;
